<template lang="pug">
  div
    el-tabs.content(:value="menu" @tab-click="mudarTab")
      template(v-for="tab in tabs")
        el-tab-pane(:name="tab.name")
          span(slot="label")
            | {{tab.label}} &nbsp

      div.container-tab
        router-view(
          :oficios="oficios"
          :processo="processo"
          :processoArrecadacao="processo"
          @atualizarOficios="atualizarOficios"
        )
</template>

<script>
import { mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'

const CADASTRO_COLETIVO_EMPTY = {
  dataFinalizacao: null,
  georreferenciamento: {
    geom: null,
    area: 0,
    perimetro: 0,
    municipios: [{ nome: null }]
  },
  pecaTecnica: {
    memorialDescritivo: null
  },
  usuario: {
    pessoa: {
      nomeRazaoSocial: ''
    }
  },
  perfil: { nome: '' }
}

const PROCESSO_EMPTY = {
  numeroProcesso: null,
  cadastroColetivo: cloneDeep(CADASTRO_COLETIVO_EMPTY),
  despachos: []
}

const OFICIO_CERTIDAO_NEGATIVA_EMPTY = {
  numeroOficio: null,
  dataEmissao: new Date(),
  cartorio: {
    nome: null,
    id: null,
    municipio: {
      id: null,
      nome: null
    }
  },
  processo: cloneDeep(PROCESSO_EMPTY)
}

export default {
  data () {
    return {
      processo: cloneDeep(PROCESSO_EMPTY),
      oficio: cloneDeep(OFICIO_CERTIDAO_NEGATIVA_EMPTY),
      oficios: []
    }
  },

  created () {
    const { idProcesso } = this.$route.query

    try {
      if (idProcesso) {
        this.findByIdProcesso(idProcesso).then(response => {
          this.processo = response
        })
      } else {
        this.goToListagem()
      }
    } catch (error) {
      this.goToListagem()
    }
  },

  computed: {
    indexTabAtual () {
      return this.tabs.findIndex(tab => tab.name === this.$route.name)
    },

    tabs () {
      const acoes = []

      acoes.push({
        label: 'Emissão do ofício',
        name: 'oficio/emissao',
        dadosRequest: {
          url: '',
          dados: this.oficios
        }
      })
      acoes.push({
        label: `Análise do processo ${this.processo.numeroProcesso}`,
        name: 'oficio/analise'
      })

      return acoes
    },

    menu () {
      return this.$route.name
    },

    isPrimeiroPasso () {
      return this.indexTabAtual === 0
    },

    isUltimoPasso () {
      return this.indexTabAtual === this.tabs.length - 1
    }
  },

  methods: {
    ...mapActions({
      findByIdProcesso: 'processoArrecadacao/findById'
    }),

    goToListagem () {
      this.$router.push({
        name: 'cpat/home'
      })
    },

    atualizarOficios (oficios) {
      this.oficios = oficios
    },

    mudarTab (componente) {
      const indexTab = this.tabs.findIndex(
        tab => tab.name === componente._props.name
      )
      this.navigate(indexTab)
    },

    async navigate (indexTab) {
      const query = {}
      query.idProcesso = this.processo.id

      try {
        this.$router.push({
          name: this.tabs[indexTab].name,
          query
        })
      } catch (error) {
        throw error
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$font-size-small: 12px;

.content {
  flex: 1;
  padding-top: 10px;
}

.container-tab {
  padding: 10px;
}

pre {
  font-size: $font-size-small;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/Oficio.vue